import WidgetGalleryPresentation from 'components/WidgetGallery/WidgetGalleryPresentation'

export default {
  Presentation: WidgetGalleryPresentation,
}
